import { render, staticRenderFns } from "./SetSimCardsUsageLimit.vue?vue&type=template&id=49df2fe2&scoped=true&"
import script from "./SetSimCardsUsageLimit.vue?vue&type=script&lang=js&"
export * from "./SetSimCardsUsageLimit.vue?vue&type=script&lang=js&"
import style0 from "./SetSimCardsUsageLimit.vue?vue&type=style&index=0&id=49df2fe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df2fe2",
  null
  
)

export default component.exports